// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h4Azg{word-wrap:break-word;overflow-wrap:break-word}.CP9xp{white-space:pre-wrap;word-wrap:break-word;overflow-wrap:break-word}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subjectText": `h4Azg`,
	"messageText": `CP9xp`
};
export default ___CSS_LOADER_EXPORT___;
